import { add, subtract, bignumber } from 'mathjs'
import { feeInfo } from './config'

function capUpperCase(str) {
	return str.slice(0, 1).toUpperCase() + str.slice(1)
}

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { injured } = this
	let injuredArr = injured.injuredList,
		costTableInfo = []

	if (!(injuredArr && injuredArr.length > 0)) {
		return
	}

	injuredArr.forEach((singleInjured, index) => {
		let singleTable = [],
			diffTotal = '',
			actualCostExist = false
		if (
			singleInjured.agreement &&
			singleInjured.agreement.conciliationStatus !== '0'
		) {
			feeInfo.forEach((costItem, key) => {
				if (costItem.id in singleInjured.agreement) {
					let actualCost = singleInjured.agreement[costItem.actual]
					if (typeof actualCost !== 'undefined') {
						// 存在已录入的实际金额
						actualCostExist = true
						if (!diffTotal) {
							diffTotal = 0
						}
						diffTotal = add(
							bignumber(diffTotal),
							subtract(
								bignumber(singleInjured.agreement[costItem.id]),
								bignumber(actualCost)
							)
						)
					}
					singleTable.push({
						key: key + 1,
						index: key + 1,
						id: costItem.id,
						costName: `${costItem.name}${
							costItem.desc ? `：${costItem.desc}` : ''
						}`,
						targetCost: singleInjured.agreement[costItem.id],
						actualCost: actualCost,
						diff: '',
						// diff: actualCost ? Number(singleInjured.agreement[costItem.id]) - Number(actualCost) : ''
						agreementId: singleInjured.agreement.id,
						injuredName: singleInjured.injuredName,
					})
				}
			})
			let actualCostSum = actualCostExist
				? singleInjured.agreement && singleInjured.agreement.conciliateSumFee
				: ''
			singleTable.push({
				key: `singleInjured${index}`,
				index: '',
				id: 'sumFee',
				costName: '',
				targetCost: `总计：${singleInjured.agreement &&
					singleInjured.agreement.sumFee}`,
				actualCost: `总计：${actualCostSum}`,
				diff: `调解减损：${diffTotal}`,
				agreementId: singleInjured.agreement.id,
				injuredName: singleInjured.injuredName,
			})
		}
		costTableInfo.push(singleTable)
	})

	return costTableInfo
}
